import { useEffect } from 'react';
import { SmartChatTypes, SmartCheck } from '../states';
export var useTimeout = function (debouncedChange, chatState, chatDispatch) {
    var showSendCodeAction = chatState.showSendCodeAction, showChangePhoneAction = chatState.showChangePhoneAction, timerValue = chatState.timerValue, checkpoint = chatState.checkpoint;
    // start the timer on phone number validation success.
    useEffect(function () {
        if (checkpoint === SmartCheck.ON_CODE_VALIDATION_CHECK) {
            chatDispatch({ type: SmartChatTypes.START_TIMEOUT });
        }
    }, [checkpoint]);
    // stop the time when code is validated
    useEffect(function () {
        if (checkpoint === SmartCheck.ON_FINAL_CHECK) {
            chatDispatch({ type: SmartChatTypes.IS_TIMEDOUT, payload: false }); // stop the timeout
        }
    }, [checkpoint]);
    // on every debouncedChange, reset the timeout
    useEffect(function () {
        if (checkpoint === SmartCheck.ON_CODE_VALIDATION_CHECK && !(showSendCodeAction || showChangePhoneAction)) {
            // if timeout actions are already shown, then don't reset
            chatDispatch({ type: SmartChatTypes.RESET_TIMEOUT });
            chatDispatch({ type: SmartChatTypes.IS_TIMEDOUT, payload: false });
        }
    }, [debouncedChange]);
    // a timer, which ticks in every second.
    useEffect(function () {
        var timer = timerValue > 0 &&
            checkpoint === SmartCheck.ON_CODE_VALIDATION_CHECK &&
            setInterval(function () { return chatDispatch({ type: SmartChatTypes.UPDATE_TIMEOUT }); }, 1000);
        if (timerValue === 0) {
            //  means it is timedout
            chatDispatch({ type: SmartChatTypes.IS_TIMEDOUT, payload: true });
        }
        return function () { return clearInterval(Number(timer)); };
    }, [timerValue]);
};
//# sourceMappingURL=useTimeout.js.map